// extracted by mini-css-extract-plugin
module.exports = {"wrap":"CreatePricing_wrap__3U8e2","button":"CreatePricing_button__1eF2t","addIcon":"CreatePricing_addIcon__3x8F-"};